module.exports = __webpack_public_path__ + "static/beyondunity-logo.70cd9967.svg";